module.exports = __webpack_public_path__ + "assets/media/day17.6d1bed58.mp3";